import {
  IEntryRecordParametersTranslator,
  IEntryRecordLabels,
  IGenericRequestParametersTranslator,
  IModificationRecordLabels,
  IModifiedRecordParametersTranslator,
  INamedEntityLabels,
  IPaginationParametersTranslator,
  IPermissionedEntityLabels,
  IRelatedEntityLabels,
  PropertyTranslator,
} from "./GenericTranslator";
import {
  IGenericRequestParameters,
  IModelWithIntId,
  INamedEntity,
  IPaginationParameters,
  IPermissionedEntity,
  EntityConstants,
  IEntryRecord,
  IModificationRecord,
  ICreatedRecordParameters,
  IModifiedRecordParameters,
  EntryRecordOrderBy,
  ModificationRecordOrderBy,
  GenericEntityOrderBy,
  IRelation,
  IRelationModel,
  IRelatedEntity,
  IEntityMinimalModel,
  NamedEntityOrderBy,
} from "./GenericTypes";
import { Permission } from "./Permission";

export const rolesConstants: EntityConstants<Role, RoleFilters> = {
  resource: "roles",
  frontendIndexRoute: "roles",
  entitySingular: "role",
  entityPlural: "roles",
  icon: "users",
};

export const RoleFieldLabels: PropertyTranslator<Role> = {
  ...INamedEntityLabels,
  ...IPermissionedEntityLabels,
  ...IRelatedEntityLabels,
  ...IEntryRecordLabels,
  ...IModificationRecordLabels,
  id: "Role ID",
  description: "Description",
  isInternal: "Internal",
  isDefault: "Default",
  rolePermissions: "Roles",
} as const;

export interface Role
  extends IModelWithIntId,
    IPermissionedEntity,
    INamedEntity,
    IEntryRecord,
    IModificationRecord,
    IRelatedEntity<RoleRelations> {
  description: string;
  isInternal: boolean;
  isDefault: boolean;
  rolePermissions: Permission[];
}
export interface RoleSuggestions extends IEntityMinimalModel<Role["id"]> {}

export interface RoleRelations extends IRelationModel {
  persons: IRelation;
}
export interface RoleFilters
  extends IGenericRequestParameters<Role, RoleSortingOptions>,
    IPaginationParameters,
    ICreatedRecordParameters,
    IModifiedRecordParameters {
  includeInternals?: boolean | null;
}
export const RoleFiltersTranslator: PropertyTranslator<RoleFilters> = {
  ...IGenericRequestParametersTranslator,
  ...IPaginationParametersTranslator,
  ...IEntryRecordParametersTranslator,
  ...IModifiedRecordParametersTranslator,
  includeInternals: "Include internal roles",
} as const;

export const RoleSortingOptionsConsts = [
  ...GenericEntityOrderBy,
  ...NamedEntityOrderBy,
  ...EntryRecordOrderBy,
  ...ModificationRecordOrderBy,
  "IS_INTERNAL",
] as const;
export type RoleSortingOptions = (typeof RoleSortingOptionsConsts)[number];
